import axios from 'axios';
import { getServerBaseUrl } from './portConfig';

/**
 * Axios 기본 설정을 구성하는 함수
 * API 요청에 대한 기본 URL 설정 등을 처리합니다
 */
export const setupAxios = () => {
  // 기본 URL 설정
  axios.defaults.baseURL = getServerBaseUrl();
  
  // 타임아웃 설정 (필요시 조절)
  axios.defaults.timeout = 10000; // 10초
  
  // Content-Type 설정
  axios.defaults.headers.common['Content-Type'] = 'application/json';
  
  console.log('Axios가 다음 URL로 설정되었습니다:', axios.defaults.baseURL);
};
